"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
var _jsxruntime = require("react/jsx-runtime");
var _core = require("@mantine/core");
var _react = require("react");
var _skipLinkmodulecss = /*#__PURE__*/ _interop_require_default(require("../../../dist/assets/components/skipLink.module.css"));
var _clsx = /*#__PURE__*/ _interop_require_default(require("clsx"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var LinkButton = (0, _core.createPolymorphicComponent)(/*#__PURE__*/ (0, _react.forwardRef)(function(_param, ref) {
    var children = _param.children, others = _object_without_properties_loose(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_core.Button, _extends({
        component: "a"
    }, others, {
        ref: ref,
        children: children
    }));
}));
var SkipLink = function(param) {
    var titleID = param.titleID, className = param.className;
    var handleClickSkipLink = function(e) {
        e.currentTarget.blur();
    };
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(LinkButton, {
        variant: "outline",
        href: "#" + titleID,
        onClick: handleClickSkipLink,
        className: (0, _clsx.default)([
            _skipLinkmodulecss.default.skipLinkButton,
            className
        ]),
        children: "Skip to main content"
    });
};
var _default = SkipLink;
